module.exports = __webpack_public_path__ + "img/default.4e533769.svg";